var _linearGradient, _path, _linearGradient2, _circle, _linearGradient3, _path2, _linearGradient4, _path3, _linearGradient5, _path4, _linearGradient6, _path5, _linearGradient7, _path6, _linearGradient8, _path7, _linearGradient9, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncomeStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: -7747.177,
    y1: -968.737,
    x2: -7746.177,
    y2: -968.737
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M50.078 9.51h4.174v6.048H31.167V9.51h3.989M35.156 9.51a6.132 6.132 0 01-.082-.993c0-3.68 3.375-6.662 7.543-6.662 4.164 0 7.543 2.982 7.543 6.662 0 .339-.029.668-.082.993"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 39.474,
    y1: 7.469,
    x2: 45.761,
    y2: 7.469
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.617,
    cy: 7.469,
    r: 2.518,
    fill: "none",
    stroke: "url(#SVGID_1_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 29.287,
    y1: 38.909,
    x2: 55.739,
    y2: 38.909
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_2_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.912 38.909h25.202"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 29.287,
    y1: 44.013,
    x2: 55.739,
    y2: 44.013
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_3_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.912 44.013h25.202"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 29.287,
    y1: 49.116,
    x2: 55.739,
    y2: 49.116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_4_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.912 49.116h25.202"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 29.287,
    y1: 54.219,
    x2: 55.739,
    y2: 54.219
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_5_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M29.912 54.219h25.202"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 32.584,
    y1: 30.705,
    x2: 37.446,
    y2: 30.705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_6_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M33.209 22.5h3.612v16.409h-3.612z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 40.278,
    y1: 33.776,
    x2: 45.14,
    y2: 33.776
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_7_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M40.903 28.642h3.612v10.267h-3.612z"
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34",
    gradientUnits: "userSpaceOnUse",
    x1: 48.13,
    y1: 36.152,
    x2: 52.991,
    y2: 36.152
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "var(--icon-menu-gradient-start, #7a0399)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "var(--icon-menu-gradient-end, #b10372)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#SVGID_8_94768fb06e5412a20550100058bac3102d3c2d36897a75e3c3e15a1237ef3d34)",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M48.755 33.394h3.612v5.515h-3.612z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M54.288 12.478h5.499c1.157 0 2.094 1.039 2.094 2.32v45.326c0 1.281-.938 2.32-2.094 2.32H25.213c-1.157 0-2.095-1.039-2.095-2.32V14.798c0-1.281.938-2.32 2.095-2.32h5.743"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomeStatement);
export default __webpack_public_path__ + "static/media/incomeStatement.d6376c647329a28fbac013461e065ff9.svg";
export { ForwardRef as ReactComponent };